import { useMutation, useQueryClient } from '@tanstack/react-query';
import { mediaKitsApi } from '~/api/mediaKits';
import { logger } from '~/core/logger/logger';
import { MEDIA_KIT } from '~/queries/keys';
import { MEDIA_KITS_DD_SECTION } from '~/screens/PageBuilder';
import { AnyBlock } from '~/screens/PageBuilder/types';

import { MediaKit } from './get';

type Payload = {
  name?: string;
  blocks?: AnyBlock[];
};

export const useUpdateMediaKit = ({ id }: { id: string }) => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (body: Payload) =>
      mediaKitsApi.patch(`custom-shareable/${id}`, {
        ...body,
      }),

    onMutate: (payload) => {
      const mediaKitData = qc.getQueryData([MEDIA_KIT, { id }]) as MediaKit;
      qc.setQueryData([MEDIA_KIT, { id }], {
        ...mediaKitData,
        ...payload,
      });
    },

    onSettled: (_data, _err, payload) => {
      if (payload.name) {
        // Name was updated hence invalidate media kits list
        qc.invalidateQueries([MEDIA_KIT]);
      }
    },

    onError: (error) => {
      logger
        .withMetadata({
          error,
          section: MEDIA_KITS_DD_SECTION,
        })
        .error('Media Kit update Error');
    },
  });
};
